import { get, post, postExFile } from "@utils/httpUtil";

// 获取所有系统菜单
export function allSysMenu(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/sysmenu/v2/allSysMenu`, data, config);
}

// 分页查询社区成员
export function getComtyAccountList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/account/pageAccount`, data, config);
}

// 查询当前社区的角色
export function findCommunityRole(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/v2/account/findCommunityRole`, data, config);
}

// 查询当前社区用户的角色列表
export function getComtyRoleList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/role/pageRole`, data, config);
}

// 当前社区新增角色
export function newComtyAddRole(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/role/addRole`, data, config);
}
// 当前社区更新角色
export function newComtyUpdateRole(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/role/updateRole`, data, config);
}
// 查询角色和菜单信息
export function newComtygetRoleAndMenu(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/v2/role/getRoleAndMenu`, data, config);
}

// 确认社区角色名称是否有效
export function checkRoleNameAvailable(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/role/checkRoleNameAvailable`, data, config);
}

// 社区删除角色
export function newComtyDeleteRole(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/v2/role/deleteRole`, data, config);
}

// 添加成员
export function newComtyAddAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/account/addAccount`, data, config);
}

// 编辑成员
export function newComtyUpdateAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/account/updateAccount`, data, config);
}

// 删除成员
export function newComtyDeleteAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/v2/account/deleteAccount`, data, config);
}

// 批量删除成员
export function newComtyBatchDeleteAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/v2/account/batchDeleteAccount`, data, config);
}

// 停用成员
export function newComtyInvalidAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/v2/account/invalidAccount`, data, config);
}

// 启用成员
export function newComtyValidAccount(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/v2/account/validAccount`, data, config);
}
